import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { FormType } from '@sb-tools/typescript/enums/form-type.enum';
import { ClientField } from '../../../common/models/client-field.model';
import { NgClass } from '@angular/common';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { WhitespaceValidatorDirective } from '@form-field-module/common/directives/whitespace-validator.directive';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [NgClass, FormsModule, FocusDirective, WhitespaceValidatorDirective, FormFieldLabelComponent],
})
export class AddressComponent implements OnInit, OnChanges {
    @Input() formField: Field | ClientField;
    @Input() formType: FormType;

    addressPlaceholder = '';
    zipCodePlaceholder = '';

    constructor(public formService: FormService) {}

    ngOnInit() {
        this.zipCodePlaceholder =
            (this.formField.options?.zipCodePlaceholder || '') +
            (this.formField.options?.isZipCodeRequired === 'true' ? ' *' : '');

        this.addressPlaceholder =
            (this.formField.options?.addressPlaceholder || '') +
            (this.formField.options?.isAddressRequired === 'true' ? ' *' : '');

        this.formField.valueModel = { zipCode: '', address: '' };

        if (this.formField.value) {
            const valueArray = this.formField.value.split(',');

            const zipValue = valueArray[0];
            const addressValue = valueArray[1];

            if (!isNaN(+zipValue)) {
                this.formField.valueModel.zipCode = zipValue.trim();
            }

            if (addressValue) {
                this.formField.valueModel.address = addressValue.trim();
            }

            this.change();
        }
    }

    ngOnChanges() {
        this.formField.valueModel = { zipCode: '', address: '' };
    }

    change() {
        this.formField.value =
            (this.formField.valueModel.zipCode?.trim() || '') +
                (this.formField.valueModel.address?.trim() ? ', ' : '') +
                this.formField.valueModel.address?.trim() || '';
    }

    isRequiredZipCodeEmpty(): boolean {
        return this.formField.options?.isZipCodeRequired === 'true' && !this.formField.valueModel.zipCode?.trim();
    }

    isRequiredAddressEmpty(): boolean {
        return this.formField.options?.isAddressRequired === 'true' && !this.formField.valueModel.address?.trim();
    }

    isRequiredValueEmpty(): boolean {
        if (this.formType === FormType.inboxSearch) {
            return !(this.formField.valueModel.zipCode || this.formField.valueModel.address);
        } else {
            return this.isRequiredZipCodeEmpty() || this.isRequiredAddressEmpty();
        }
    }
}
